/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/views/layout/Layout'

const componentsRouter = {
    path: '/card',
    component: Layout,
    name: 'Card',
    menuid: 214,
    systemtypeid: 7,
    meta: {
      title: 'CardTitle',
      icon: 'excel'
    },
    children: [
      {
        path: 'cardtype/index',
        component: () => import('@/views/card/cardtype/list'),
        name: 'CardTypeList',
        menuid: 215,
        systemtypeid: 7,
        meta: {title: 'CardTypeList', icon: 'dashboard'}
      }, 
      {
        path: 'userdetail/index',
        component: () => import('@/views/card/userdetail/list'),
        name: 'UserDetailList',
        menuid: 223,
        systemtypeid: 7,
        meta: {title: 'UserDetailList', icon: 'user'}
      },
      {
        path: 'usercard/index',
        component: () => import('@/views/card/usercard/list'),
        name: 'UserCardList',
        menuid: 216,
        systemtypeid: 7,
        meta: {title: 'UserCardList', icon: 'excel'}
      },
      {
        path: 'payorder/index',
        component: () => import('@/views/card/payorder/list'),
        name: 'PayOrderList',
        menuid: 228,
        systemtypeid: 7,
        meta: {title: 'PayOrderList', icon: 'clipboard'}
      },
      {
        path: 'log/index',
        component: () => import('@/views/card/log/list'),
        name: 'CardKeyLogList',
        menuid: 232,
        systemtypeid: 7,
        meta: {title: 'CardKeyLogList', icon: 'link'}
      },
      {
        path: 'download/index',
        component: () => import('@/views/card/download/list'),
        name: 'DownloadList',
        menuid: 232,
        systemtypeid: 7,
        meta: {title: 'DownloadList', icon: 'clipboard'}
      },

      
    ]
  }

export default componentsRouter



// WEBPACK FOOTER //
// ./src/router/modules/card.js